package document

open class DocException(message: String?=null, cause: Throwable?=null): Exception(message, cause)

open class BlockNotFoundException(message: String?=null, cause: Throwable?=null): Exception(message, cause)

class BugException(message: String?=null,cause: Throwable?=null): DocException(message, cause)
class BadStructureException(message: String?=null,cause: Throwable?=null): DocException(message, cause)